import * as React from "react";
import { connect } from "react-redux";

import SupportUsers from "../../screens/SupportUsers";
import {
  addSupportUsers,
  supportUsersViewList,
  deleteSupportUsers,
  editSupportUsers,
  supportUsersSearch,
  supportUsersSlectedPage,
} from "./action";
class SupportUsersContainer extends React.Component<Props, State> {
  render() {
    return (
      <SupportUsers
        supportUsersViewList={this.props.supportUsersViewList}
        addSupportUsers={this.props.addSupportUsers}
        supportUsersList={this.props.supportUsersList}
        deleteSupportUsers={this.props.deleteSupportUsers}
        editSupportUsers={this.props.editSupportUsers}
        supportUsersDtlsCount={this.props.supportUsersDtlsCount}
        supportUsersSearchList={this.props.supportUsersSearchList}
        supportUsersSearch={this.props.supportUsersSearch}
        supportUsersSlectedPage={this.props.supportUsersSlectedPage}
        supportUsersSearchCount={this.props.supportUsersSearchCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    supportUsersViewList: () => {
      dispatch(supportUsersViewList());
    },
    addSupportUsers: (value) => {
      dispatch(addSupportUsers(value));
    },
    deleteSupportUsers: (items) => {
    
      dispatch(deleteSupportUsers(items));
    },
    editSupportUsers: (value) => {
    
      dispatch(editSupportUsers(value));
    },
    supportUsersSearch: (value) => {
     
      dispatch(supportUsersSearch(value));
    },
    supportUsersSlectedPage: (value) => {
    
      dispatch(supportUsersSlectedPage(value));
    },
  };
}
function mapStateToProps(state) {
  return {
    supportUsersList: state.SupportUsersReducer.supportUsersList,
    supportUsersDtlsCount: state.SupportUsersReducer.supportUsersDtlsCount,
    supportUsersSearchList: state.SupportUsersReducer.supportUsersSearchList,
    supportUsersSearchCount: state.SupportUsersReducer.supportUsersSearchCount,
  };
}

export default connect(mapStateToProps, bindAction)(SupportUsersContainer);
